// extracted by mini-css-extract-plugin
module.exports = {"details_headings":"Details_details_headings__lv2VT"};